import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AgentChatController } from '../../services/agent-chat.controller';
import { AgentAccessService } from '../../services/agent-access.service';
import { AgentConversation } from '../../services/agent-chat.service';

@Component({
  selector: 'app-agent-chat-widget',
  templateUrl: './agent-chat-widget.component.html',
  styleUrls: ['./agent-chat-widget.component.sass'],
  providers: [AgentChatController],
})
export class AgentChatWidgetComponent
  implements OnInit, OnDestroy, AfterViewChecked
{
  @ViewChild('widgetChat') widgetChat!: ElementRef;

  isVisible = false;
  isOpen = false;
  inputMessage = '';
  showConversationList = false;
  deepMode = false;

  private shouldScroll = false;

  constructor(
    public ctrl: AgentChatController,
    private agentAccess: AgentAccessService,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit(): Promise<void> {
    this.isVisible = await this.agentAccess.checkAccess();
    if (!this.isVisible) return;

    this.ctrl.onStateChange = () => {
      this.shouldScroll = true;
      this.cdr.markForCheck();
    };
    this.ctrl.init();
  }

  ngAfterViewChecked(): void {
    if (this.shouldScroll) {
      this.scrollToBottom();
      this.shouldScroll = false;
    }
  }

  ngOnDestroy(): void {
    this.ctrl.ngOnDestroy();
  }

  async toggleChat(): Promise<void> {
    this.isOpen = !this.isOpen;
    if (this.isOpen && !this.ctrl.currentConversation) {
      await this.ctrl.loadConversations(1, 20);
      if (this.ctrl.conversations.length > 0) {
        await this.ctrl.selectConversation(this.ctrl.conversations[0]);
      }
    }
  }

  async newConversation(): Promise<void> {
    await this.ctrl.newConversation();
    this.showConversationList = false;
  }

  async selectConversation(conv: AgentConversation): Promise<void> {
    await this.ctrl.selectConversation(conv);
    this.showConversationList = false;
  }

  async sendMessage(): Promise<void> {
    const text = this.inputMessage.trim();
    if (!text) return;
    this.inputMessage = '';
    if (this.deepMode) {
      await this.ctrl.sendMessageAsyncMode(text);
    } else {
      await this.ctrl.sendMessage(text);
    }
  }

  stopStreaming(): void {
    this.ctrl.stopStreaming();
  }

  toggleDeepMode(): void {
    this.deepMode = !this.deepMode;
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  formatToolName(name: string): string {
    return this.ctrl.formatToolName(name);
  }

  private scrollToBottom(): void {
    try {
      const el = this.widgetChat?.nativeElement;
      if (el) el.scrollTop = el.scrollHeight;
    } catch {}
  }
}
